import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CalendarLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("rect", { width: 18, height: 15, x: 3, y: 6, stroke: "currentColor", rx: 2 }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M3 11h18M9 16h6M8 3v4M16 3v4" })));
}
const CalendarLight = forwardRef(_CalendarLight);
export { CalendarLight };
